import { z } from 'zod';
/**
 * AI-Smart-Assistant (Skill `ai-smart-assistant`, Paket I).
 *
 * Companion-Bot, der unten rechts floatet und über GPT-4o-mini mit Streaming
 * antwortet. Kennt optional den aktuellen Projektkontext (Status, Frist, Lead,
 * Pflichtfelder, letzte Kommentare).
 *
 * Streaming-Format: SSE (Server-Sent Events) — siehe `routes.ts`. Kein
 * EventSource im Browser (würde keine Bearer-Auth tragen), stattdessen
 * `fetch` mit ReadableStream-Parsing.
 */
export const assistantMessage = z
    .object({
    role: z.enum(['user', 'assistant']),
    content: z.string().min(1).max(4000),
})
    .strict();
/**
 * Help-Snippet aus der client-seitigen Wiki-Suche (Self-Learning RAG).
 * Der Frontend-Client durchsucht Hilfekapitel via Lunr und schickt die Top-K
 * Treffer als Kontext mit — Backend hängt sie ans System-Prompt an, sodass
 * der Assistant Wiki-Inhalte zitieren kann ohne sie zu halluzinieren.
 *
 * Snippets sind als Vertrauenswürdig zu behandeln (kommen aus app-eigenem
 * Content, nicht User-Input).
 */
export const helpContextSnippet = z
    .object({
    slug: z.string().min(1).max(100),
    title: z.string().min(1).max(300),
    snippet: z.string().min(1).max(2000),
})
    .strict();
export const assistantChatRequest = z
    .object({
    messages: z.array(assistantMessage).min(1).max(20),
    projectId: z.number().int().positive().optional(),
    /** Top-K Lunr-Treffer aus dem Hilfe-Center, vom Frontend gesammelt. */
    helpContext: z.array(helpContextSnippet).max(5).optional(),
})
    .strict();
export const botPositionSchema = z.enum(['bottom-right', 'bottom-left', 'top-right', 'top-left']);
export const updateBotPreferencesRequest = z
    .object({
    botPosition: botPositionSchema.optional(),
    botVisible: z.boolean().optional(),
    motionScale: z.number().min(0).max(2).optional(),
})
    .strict();
